module.exports = "<a  [title]=\"model.displayName\" (click)=\"download()\" *ngIf=\"model\">{{ model.displayName || \"...\" }}</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/workflows/content-renderer/document-link-viewer/document-link-viewer.component.html
// module id = 731
// module chunks = 1 2